import { Injectable } from '@angular/core';
import { HttpClientService } from '../../../http-client.service';
import { environment } from '../../../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class NotificationService {
  userEmail ;
  private readonly restApiURL: string;
  private statusTypes = [{
    label: 'Select All',
    pref: {
      Phone: false,
      Email: false
    }
  }, {
    label: 'Shipped',
    pref: {
      Phone: false,
      Email: false
    }
  }, {
    label: 'Delivery Approaching',
    pref: {
      Phone: false,
      Email: false
    }
  }, {
    label: 'Delivered',
    pref: {
      Phone: false,
      Email: false
    }
  }];

  private options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
  noPreferences: boolean = false;
  hasContact: boolean = true;
  constructor(private httpClientService: HttpClientService) {
    this.restApiURL = environment.apiHost;

  }

 
  

  getNotificationStatus(deliveryId, email) {  
  return this.httpClientService.get<any>(`${this.restApiURL}/preferences?deliveryId=${deliveryId}&email=${email}`, this.options).pipe(
      map((response: any) => {
          if(response.nopreferences){
            this.noPreferences = true;
          }
          this.convertToStatusTypes(response[0]);
          return this.statusTypes;
        }
      ), catchError((err: any) => throwError(err)));
  }

  savePreferences(prefrences) {
    if (this.noPreferences) {
      return this.httpClientService.post<any>(`${this.restApiURL}/preferences`, prefrences).pipe(
        map((response: any) =>
          response
        ));
    } else {
      return this.httpClientService.put<any>(`${this.restApiURL}/preferences`, prefrences).pipe(
        map((response: any) =>
          response
        ));
    }
  }

  convertToStatusTypes(obj1) {
    for (let key in obj1) {
      if (typeof obj1[key] === 'boolean' && key !== 'Select All') {
        this.statusTypes.forEach((status) => {
          if (key.includes(status.label.split(" ")[0])) {
            for (let ke2 in status.pref) {
              if (key.includes(ke2)) {
                status.pref[ke2] = obj1[key];
              }
            }
          }
        });
      }
    }
  }

  getUserContact(userEmail:string) {
    return this.httpClientService.get<any>(`${this.restApiURL}/contact?emailId=${userEmail}`, this.options).pipe(
      map((response: any) => {
        if (response && !response.message) {
          this.hasContact = !!(response.PhoneCountryCode && response.PhoneNumber);
        }
        return response;
      }), catchError((err: any) => throwError(err)));
  }

  updateUserContact(contact: {
    email: string,
    PhoneCountryCode: string,
    PhoneNumber: string
  }) {
    return this.httpClientService.put<any>(`${this.restApiURL}/contact`, contact).pipe(
      map((response: any) => {
        this.hasContact = !!(contact.PhoneCountryCode && contact.PhoneNumber);
        return response;
      }));
  }

  resetStatusTypes(){
    this.statusTypes.map((status) => {
      status.pref.Phone = false;
      status.pref.Email = false;
      return status;
    });
  }
}
